import React from "react";
import { Box } from "@mui/material";
import ReactGA from "react-ga4";
// import { data_index } from "./dataIndex";

const Header: React.FC<{}> = () => {
  const challengeIndex = (
    (Number(localStorage.getItem("ChallengeIndex")) || 0) + 1
  )
    .toString()
    .padStart(3, "0");

  const toHowToPlay = () => {
    const path = "https://www.sunmark.co.jp/view.php?cid=p4024";
    ReactGA.event("page_link", { path });
    window.location.href = path;
  };
  return (
    <Box
      m={-1}
      mb={0}
      px={2}
      bgcolor="#eee"
      display="flex"
      sx={{ py: { xs: 1, md: 1.5 } }}
    >
      <Box fontFamily="yasashisa" sx={{ fontSize: { md: 23 } }}>
        もんだい{challengeIndex}
      </Box>
      <Box
        fontFamily="yasashisa"
        onClick={toHowToPlay}
        style={{ cursor: "pointer", textDecoration: "underline" }}
        color="#1976d2"
        flexDirection={"row"}
        display="flex"
        ml={"auto"}
        sx={{ fontSize: { xs: 11, md: 18 }, mr: { md: 3 }, mt: { xs: 0.5 } }}
      >
        遊び方はこちら
      </Box>
    </Box>
  );
};

export default Header;
